import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { sequences } from 'app/pwa/app.cerebral';

import {
  Container,
  Wrapper,
  Image,
  Title,
  Text,
  ContinueButton,
  MainContent,
} from './elements';
import { useText, useConfig } from 'common/hooks';

const deps = {
  continueFromSetPassword: sequences`account.continueFromSetPassword`,
};

export function CheckEmail({
  continueFromSetPassword,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  return (
    <Container>
      <Wrapper>
        <MainContent>
          <Image alt={''} src={`${staticUrl}/images/password-icon.png`} />
          <Title as={'h1'}>{t('authentication.password_created')}</Title>
          <Text>{t('authentication.use_next_time')}</Text>
          <ContinueButton onClick={() => continueFromSetPassword()}>
            {t('authentication.continue')}
          </ContinueButton>
        </MainContent>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, CheckEmail);
